/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DuplicateCMAResponseDto
 */
export interface DuplicateCMAResponseDto {
    /**
     * 
     * @type {string}
     * @memberof DuplicateCMAResponseDto
     */
    newlyCreatedCMAId: string;
}

/**
 * Check if a given object implements the DuplicateCMAResponseDto interface.
 */
export function instanceOfDuplicateCMAResponseDto(value: object): value is DuplicateCMAResponseDto {
    if (!('newlyCreatedCMAId' in value) || value['newlyCreatedCMAId'] === undefined) return false;
    return true;
}

export function DuplicateCMAResponseDtoFromJSON(json: any): DuplicateCMAResponseDto {
    return DuplicateCMAResponseDtoFromJSONTyped(json, false);
}

export function DuplicateCMAResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DuplicateCMAResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'newlyCreatedCMAId': json['newlyCreatedCMAId'],
    };
}

export function DuplicateCMAResponseDtoToJSON(json: any): DuplicateCMAResponseDto {
    return DuplicateCMAResponseDtoToJSONTyped(json, false);
}

export function DuplicateCMAResponseDtoToJSONTyped(value?: DuplicateCMAResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newlyCreatedCMAId': value['newlyCreatedCMAId'],
    };
}

